import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../../CommonComponents/Modal';
import { DangerButton, SecondaryButton } from '../../../CommonComponents/Button';
import { isCancellingSubscriptionSelector } from '../../ExperianSelector';
import { cancelSubscription } from '../../ExperianActions';
import { Wrapper, Footer } from './CancelMonitoringModalStyles';
import Spinner from '../../../CommonComponents/Spinner';
import ExperianContext from '../../ExperianContext';

const CancelMonitoringModal = ({ isOpen, onRequestClose }) => {
  const isCancellingSubscription = useSelector(isCancellingSubscriptionSelector);

  const { clientId, subscriberId } = useContext(ExperianContext);

  const dispatch = useDispatch();
  const cancelSubscriptionCallback = useCallback(async () => {
    await dispatch(cancelSubscription(clientId, subscriberId));
    onRequestClose();
  }, [clientId, subscriberId, onRequestClose, dispatch]);

  return (
    <>
      {isCancellingSubscription && <Spinner />}
      <Modal isOpen={isOpen}>
        <Wrapper>
          <h2>Are you sure you want to unenroll from your monitoring services?</h2>
          <Footer>
            <DangerButton onClick={cancelSubscriptionCallback} disabled={isCancellingSubscription}>
              Confirm
            </DangerButton>
            <SecondaryButton
              type="submit"
              onClick={onRequestClose}
              disabled={isCancellingSubscription}
            >
              Cancel
            </SecondaryButton>
          </Footer>
        </Wrapper>
      </Modal>
    </>
  );
};

CancelMonitoringModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};

export default CancelMonitoringModal;
